export const WATCH_LIST_ENTRY_MESSAGES = {
  NOT_FOUND: 'No high-risk country entries were found',
  CREATED: 'The high-risk country entry was successfully created',
  UPDATED: 'The high-risk country entry was successfully updated',
  DELETED: 'The high-risk country entry was successfully deleted',
};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/constants/watchListEntryMessages.js